import React from 'react';
import { Alert, Snackbar } from '@mui/material';

interface ErrorSnackbarProps {
  error: { open: boolean; message: string } | null;
  onClose: () => void;
}

export const ErrorSnackbar: React.FC<ErrorSnackbarProps> = ({ error, onClose }) => {
  return (
    <Snackbar
      open={!!error?.open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={onClose} severity="error" sx={{ width: '100%' }}>
        {error?.message}
      </Alert>
    </Snackbar>
  );
};



